import React from 'react'
import { NotFound, Redirect, useLocation } from '@fs/zion-router'
import { useTreeStartingPid, useGroupsContext, useLastViewedPid } from '@fs/zion-tree-groups'

type Props = {
  subPage: string
}

export function RedirectToStartingPid({ subPage }: Props): JSX.Element | null {
  const { currentTreeId } = useGroupsContext()
  const { loading: startingPidLoading, data } = useTreeStartingPid(currentTreeId || 'PRIVATE')
  const { loading: pidLoading, pid } = useLastViewedPid()

  // If there's a groupId set, use the startingPerson, not the cached last viewed pid
  const targetPid = (!currentTreeId && pid) || data?.personId

  const { search } = useLocation()

  if (startingPidLoading || pidLoading) return null

  if (!targetPid || !subPage) return <NotFound />
  return <Redirect to={`/${subPage}/${targetPid}${search}`} />
}
